import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
function getStoredDeadline(): number {
  const stored = localStorage.getItem('music_offer_deadline');
  if (stored) {
    const deadline = parseInt(stored, 10);
    if (deadline > Date.now()) return deadline;
  }
  const newDeadline = Date.now() + 48 * 60 * 60 * 1000;
  localStorage.setItem('music_offer_deadline', newDeadline.toString());
  return newDeadline;
}
function calculateTimeLeft(deadline: number): TimeLeft {
  const diff = Math.max(0, deadline - Date.now());
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
function TimeBlock({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-77">
      <div className="bg-white text-purple-700 font-nunito font-black text-2xl md:text-4xl w-14 md:w-20 h-14 md:h-20 rounded-xl flex items-center justify-center shadow-lg border-2 border-yellow-300" data-id="element-78">
        {String(value).padStart(2, '0')}
      </div>
      <span className="text-yellow-200 text-xs font-semibold mt-1 uppercase tracking-wide" data-id="element-79">
        {label}
      </span>
    </div>;
}
export function CountdownTimer() {
  const [deadline] = useState(() => getStoredDeadline());
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() => calculateTimeLeft(deadline));
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft(deadline));
    }, 1000);
    return () => clearInterval(interval);
  }, [deadline]);
  return <div className="flex flex-col items-center gap-3" data-id="element-80">
      <p className="text-yellow-300 font-nunito font-bold text-lg flex items-center gap-2" data-id="element-81">
        <Clock className="w-5 h-5" data-id="element-82" />
        OFERTA TERMINA EN:
      </p>
      <div className="flex items-center gap-3" data-id="element-83">
        <TimeBlock value={timeLeft.hours} label="Horas" data-id="element-84" />
        <span className="text-yellow-300 font-black text-3xl mb-5" data-id="element-85">:</span>
        <TimeBlock value={timeLeft.minutes} label="Minutos" data-id="element-86" />
        <span className="text-yellow-300 font-black text-3xl mb-5" data-id="element-87">:</span>
        <TimeBlock value={timeLeft.seconds} label="Segundos" data-id="element-88" />
      </div>
    </div>;
}